import {createContext} from 'preact';

export const ShadowRootContext = createContext<ShadowRoot | undefined>(
  undefined,
);
